<template>
  <form class="form form-vertical">
    <div class="form-body">
      <div class="row">
        <!-- Name -->
        <vx-input-group class="mb-5">          
          <vs-input
            label="Nome da Categoria"
            v-model="groupOfCustomer.name"
            class="w-full"
            name="nome"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('nome')"
          >
            {{ errors.first('nome') }}
          </span>
        </vx-input-group>

        <!-- Color Tag -->
        <div class="flex">
          <vx-input-group class="mb-5">
            <label class="vs-input--label">Selecione uma Etiqueta</label>
            <div class="items-center">
              <div class="relative ml-3">
                <vs-dropdown class="flex" vs-trigger-click vs-custom-content> 
                    <vs-icon icon="label" size="large" :color="groupOfCustomer.color_tag"></vs-icon>
                    <feather-icon
                      size="large"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current mt-3"
                    />
  
                  <vs-dropdown-menu >
                    <div class="rounded-md bg-white shadow-xs px-4 py-3 ">
                      <div class="grid grid-cols-4 gap-4 gap-4">
                        <div v-for="(color, index) in colors" :key="index" >
                          <template v-if="groupOfCustomer.color_tag === color">	
                            <div
                              class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white"
                              :style="`background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);`"
                            ></div>
                          </template>
  
                          <template v-if="groupOfCustomer.color_tag !== color">
                            <div
                              role="checkbox"
                              tabindex="0"
                              @click="groupOfCustomer.color_tag = color"
                              :aria-checked="groupOfCustomer.color_tag"	
                              class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white focus:outline-none focus:shadow-outline"
                              :style="`background: ${color};`"
                            ></div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </vx-input-group>

          <div class="mx-8">
            <vx-input-group class="mb-5">
              <div class="flex mt-1">
                <label class="vs-input--label">Criar com base em planilha</label>
                <vx-tooltip text="Selecione esta opção caso você queira criar uma categoria via planilha.">
                  <feather-icon class="ml-2" id="button-update" icon="HelpCircleIcon"></feather-icon>
                </vx-tooltip>
              </div>
              <div class="flex items-center">
                <div class="relative ml-12">
                  <div class="w-full flex justify-center items-center">
                    <vs-switch v-model="updateBySpreadSheet">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </div>
            </vx-input-group>
          </div>
          
          <div class="mx-8">
            <vx-input-group class="mb-5">
              <div class="flex mt-1">
                <label class="vs-input--label">Atualizar Contatos</label>
                <vx-tooltip text="Selecione esta opção caso você queira atualizar seus contatos já existentes.">
                  <feather-icon class="ml-2" id="button-update" icon="HelpCircleIcon"></feather-icon>
                </vx-tooltip>
              </div>
              <div class="flex items-center">
                <div class="relative ml-12">
                  <div class="w-full flex justify-center items-center">
                    <vs-switch v-model="updateAllInSheet" :disabled="tableData.length === 0">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </div>
            </vx-input-group>
          </div>
          
        </div>
        

        <div class="mb-5" v-if="!groupOfCustomer.id && updateBySpreadSheet">
          <span><strong>Inserir Base</strong></span>
          <import-excel
            :action="uploadApiUrl"
            fileName="file"
            :headers="{
              Authorization: 'Bearer ' + bearer
            }"
            :onSuccess="loadDataInTable"
            @on-success="successUploadSheet"
            @on-error="errorUploadSheet"
          />

          <vx-card
            v-if="tableData.length && header.length"
            class="mt-8 mb-8"
          >
            <vs-table stripe pagination :max-items="10" search :data="tableData">
              <template slot="header">
                <h4>{{ sheetName }}</h4>
              </template>

              <template slot="thead">
                <vs-th :sort-key="heading" v-for="heading in header" :key="heading">
                  {{ heading }}
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="col" v-for="(col, indexcol) in header" :key="indexcol + col">
                    {{ tr[col] }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>

        <div class="w-full mt-5 mb-5 vs-con-loading__container" id="div-loading-selected" v-if="!updateBySpreadSheet">
          <vs-row>
            <vs-col vs-w="6">
              <vs-card style="width: 98%;" :fixed-height="true">
                <div class="mb-5">
                  <div class="mt-3" style="float: left">
                    <h3>Contatos Disponíveis</h3>
                  </div>

                  <div style="float: right">
                    <vs-button 
                      color="transparent"
                      type="relief"
                      class="button-remove-bg"
                      icon="chevron_right"
                      @click="moveCustomers(currentTab, 'chosenCustomers')"
                      icon-after
                    >
                      Mover
                    </vs-button>
                  </div>

                  <div style="clear: both;"></div>
                </div>

                <vs-tabs alignment="fixed" :value="currentTabIndex" ref="availableTabs">
                  <vs-tab
                    :label="'Contatos ' + appTitle"
                    icon="people_outline"
                    @click="changeCurrentTab('customersToSelect')"
                  >
                    <div>
                      <vs-row class="pt-1">
                        <vs-col vs-w="6">
                          <vs-checkbox
                              class="mt-2"
                              type="checkbox"
                              v-model="selectAll"
                              :disabled="!customersToSelect.length"
                          >Selecionar Todos
                          </vs-checkbox>
                        </vs-col>
                        <vs-col vs-w="6">
                          <vs-input
                              class=""
                              v-model="search.pedBot"
                              name="nome"
                              icon="search"
                              style="margin-left: auto"
                              id="quickFilterPedbotContacts"
                              v-on:input="onQuickFilterPedbotContacts()"
                              :disabled="selectAll"
                          />
                        </vs-col>
                      </vs-row>
                      <ag-grid-vue
                          class="mt-3 ag-theme-balham"
                          style="width: 100%; height: 300px;"
                          :defaultColDef="defaultColumnDefs"
                          :columnDefs="columnDefs"
                          :rowData="customersToSelect"
                          rowSelection="multiple"
                          :suppressRowClickSelection="true"
                          @grid-ready="onGridReadyPedbotContacts"
                          overlayNoRowsTemplate="Sem registros encontrados"
                          :overlayLoadingTemplate="overlayLoadingTemplate"
                      ></ag-grid-vue>
                      <pagination
                          :max="7"
                          class="mt-3"
                          :total="ctsTotalPages"
                          v-model="ctsCurrentPage"
                      ></pagination>
                    </div>
                  </vs-tab>

                  <vs-tab
                    label="Contatos Importados" 
                    icon="cloud_upload" 
                    @click="changeCurrentTab('uploadedCustomers')"
                  >
                    <div>
                      <vs-input
                          v-model="search.imported"
                          name="nome"
                          icon="search"
                          style="margin-left: auto"
                          id="quickFilterImportedContacts"
                          v-on:input="onQuickFilterImportedContacts()"
                      />
                      <ag-grid-vue
                          class="mt-3 ag-theme-balham"
                          style="width: 100%; height: 300px;"
                          :defaultColDef="defaultColumnDefs"
                          :columnDefs="columnDefs"
                          :rowData="uploadedCustomers"
                          rowSelection="multiple"
                          :suppressRowClickSelection="true"
                          @grid-ready="onGridReadyImportedContacts"
                          overlayNoRowsTemplate='Sem registros encontrados'
                      ></ag-grid-vue>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </vs-card>
            </vs-col>

            <vs-col vs-w="6">
              <vs-card style="width: 98%;" :fixed-height="true">
                <div class="mb-5">
                  <div style="float: left">
                    <vs-button 
                      color="transparent"
                      type="relief"
                      class="button-remove-bg"
                      icon="chevron_left"
                      @click="moveCustomers('chosenCustomers', currentTab)"
                    >
                      Mover
                    </vs-button>
                  </div>

                  <div class="mt-3" style="float: right">
                    <h3>Contatos Selecionados</h3>
                  </div>

                  <div style="clear: both;"></div>
                </div>

                <div class="pt-16">
                  <vs-input
                      class="mb-3"
                      v-model="search.selected"
                      name="nome"
                      icon="search"
                      style="margin-left: auto"
                      id="quickFilterSelectedContacts"
                      v-on:input="onQuickFilterSelectedContacts()"
                  />
                  <ag-grid-vue
                        class="mt-3 ag-theme-balham"
                        style="width: 100%; height: 300px;"
                        :defaultColDef="defaultColumnDefs"
                        :columnDefs="columnDefs"
                        :rowData="chosenCustomers"
                        rowSelection="multiple"
                        :suppressRowClickSelection="true"
                        @grid-ready="onGridReadySelectedContacts"
                        overlayNoRowsTemplate='Sem registros encontrados'
                    ></ag-grid-vue>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
        </div>

        <!-- Submit -->
        <vx-input-group>
          <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || !groupOfCustomer.name">
            Salvar
          </vs-button>
        </vx-input-group>
      </div>
    </div>
  </form>
</template>

<script>

import ImportExcel from "@/components/excel/ImportExcel"
import Pagination from "@/components/pagination/pagination.vue";

import moduleCustomerGroup from '@/store/customerGroup/moduleCustomerGroup'
import moduleCustomer from '@/store/customer/moduleCustomer'

import { AgGridVue } from "ag-grid-vue"
import { formatRouteTenantPath, maskPhoneNumber, removeFileFromBucket } from '@/utils'

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

export default {
    name: 'customer-category-form',
    data() {
      return {
        updateAllInSheet: false,
        updateBySpreadSheet: false,
        selectAll: false,
        changeCustomers: false,
        sheetName: '',
        groupOfCustomer: {
          name: '',
          color_tag: ''
        },
        search: {
          pedBot: '',
          selected: '',
          imported: '',
        },
        // Customers to select list
        customersToSelect: [],
        customersToSelectOld: [],
        // Selected checkboxes from chosen customers table
        chosenCustomers: [],
        // Selected checkboxes from uploaded customers table
        uploadedCustomersCheckbox:[],
        // Uploaded customers list
        uploadedCustomers: [],

        currentTab: 'customersToSelect',
        searchTerm: '',
        tableData: [],
        sheet_url: '',
        update_all_in_sheet: false,
        headerTags: [],
        header: [],
        ctsCurrentPage: 1,
        ctsCurrentPageOld: 1,
        ctsTotalPages: 1,
        ctsTotalPagesOld: 1,
        ctsItemsPerPage: 30,
        defaultColumnDefs: [
          { field: "name", headerName: 'Nome', checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, width: 150},
          { field: "phone_number", headerName: 'Telefone'},
        ],
        columnDefs: this.getColumnDefs(),
        gridApiSelectedContacts: null,
        gridColumnApiSelectedContacts: null,
        gridApiPedbotContacts: null,
        gridColumnApiPedbotContacts: null,
        gridApiImportedContacts: null,
        gridColumnApiImportedContacts: null,
        overlayLoadingTemplate: null,
        disableSelectAll: false,
        colors: [
          '#ffa12f','#ff5722','#b60ca0','#e50950',
          '#6c1a54','#0491FF','#0235cc','#3f5fd0',
          '#423572','#08e0ae','#07a092','#1db954',
          '#0b6509','#6d7c21','#52391c','#757380'
        ]
      }
    },
    computed: {
      appTitle() {
        return process.env.VUE_APP_APP_TITLE;
      },
      isFormValid() {
        return !this.errors.any()
      },
      uploadApiUrl() {
        return localStorage.getItem('baseUrl') + '/api/file/upload'
      },
      bearer() {
        return this.$store.state.auth.bearer
      },
      currentTabIndex() {
        return this.currentTab === 'customersToSelect' ? '0' : '1'
      },
    },
    watch: {
      sheet_url: function(_, oldValue) {
        if (oldValue) {
          removeFileFromBucket(oldValue);
        }
      },
      ctsCurrentPage() {
        if (!this.selectAll) {
          this.fetchPaginatedCustomersToSelect()
        }
      },
      selectAll(value) {
        if (value) {
          this.gridApiPedbotContacts.showLoadingOverlay();
          this.ctsCurrentPageOld = this.ctsCurrentPage;
          this.ctsCurrentPage = 1;
          this.ctsTotalPagesOld = this.ctsTotalPages;
          this.ctsTotalPages = 1
        } else {
          this.gridApiPedbotContacts.hideOverlay();
          this.ctsCurrentPage = this.ctsCurrentPageOld;
          this.ctsTotalPages = this.ctsTotalPagesOld;
        }
      },
      updateAllInSheet: function (val) {
        this.update_all_in_sheet = val
      },
    },
    methods: {
      getColumnDefs() {
        return [
          { field: "name", headerName: 'Nome', checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, width: 150},
          { field: "phone_number", headerName: 'Telefone'},
        ]
      },
      handleSearch(searchTerm) {
        this.searchTerm = searchTerm
        this.fetchPaginatedCustomersToSelect()
      },
      changeCurrentTab(tab) {
        this.currentTab = tab
      },
      onGridReadySelectedContacts(params) {
        this.gridApiSelectedContacts = params.api;
        this.gridApiSelectedContacts.sizeColumnsToFit()
        this.gridColumnApiSelectedContacts = params.columnApi;
      },
      onGridReadyPedbotContacts(params) {
        this.gridApiPedbotContacts = params.api;
        this.gridApiPedbotContacts.sizeColumnsToFit()
        this.gridColumnPedbotContacts = params.columnApi;
      },
      onGridReadyImportedContacts(params) {
        this.gridApiImportedContacts = params.api;
        this.gridApiImportedContacts.sizeColumnsToFit()
        this.gridColumnPedbotContacts = params.columnApi;
      },
      onQuickFilterSelectedContacts() {
        this.gridApiSelectedContacts.setQuickFilter(document.getElementById('quickFilterSelectedContacts').value);
      },
      onQuickFilterImportedContacts() {
        this.gridApiImportedContacts.setQuickFilter(document.getElementById('quickFilterImportedContacts').value);
      },
      onQuickFilterPedbotContacts() {
        this.searchTerm = document.getElementById('quickFilterPedbotContacts').value;
        this.fetchPaginatedCustomersToSelect();
      },
      moveCustomerLoading() {
        this.$vs.loading({
          type: 'radius',
          container: '#div-loading-selected'
        });
      },
      excludeIdsInChosen(){
        let excludeIds = this.chosenCustomers.map(s => s.id);
        excludeIds = excludeIds.filter(f => f != null)
        if (excludeIds.length === 0) { excludeIds = [0] }

        return excludeIds.join(',')
      },
      async populateSelected(originArray) {
        if(this.selectAll) {
          let excludeIds = this.excludeIdsInChosen();

          return await this.$store.dispatch("customer/fetchByCustomerGroup", {
            deleted_at: null,
            exclude: excludeIds
          }).then(res => {
            return res.data.data.customers.items;
          })
        }

        const action = {
          customersToSelect: () => {
            return this.gridApiPedbotContacts.getSelectedNodes().map(node => node.data);
          },
          uploadedCustomers: () => {
            return this.gridApiImportedContacts.getSelectedNodes().map(node => node.data);  
          },
          chosenCustomers: () => {
            return this.gridApiSelectedContacts.getSelectedNodes().map(node => node.data);
          }
        }

        return action[originArray]();
      },
      async moveCustomers(originArray, targetArray) {
        this.$refs.availableTabs.$data.children[1].attrs.disabled = true
        if (!this.selectAll) {
          this.moveCustomerLoading();
          await this.sleep(50);
        }

        let selectedCheckboxes = await this.populateSelected(originArray);
        
        if (!selectedCheckboxes.length) {
          this.$vs.loading.close('#div-loading-selected > .con-vs-loading')
          return this.$vs.notify({
            color: 'warning',
            title: 'Atenção!',
            text: 'Selecione contatos para movê-los!'
          })
        }

        if (originArray !== 'chosenCustomers') {
          this.selectAll = false;
          // Merging into customers to select array
          this[targetArray] = [
            ...this[targetArray],
            ...selectedCheckboxes
          ]
        } else {
            this.ctsCurrentPage = 1;
            this[targetArray] = [
              ...this[targetArray],
              ...selectedCheckboxes
            ]
        }

        // Refreshing the selected checkboxes
        this.cleanSelected(selectedCheckboxes, originArray)

        // Clean duplicate values in Excel worksheet
        if (originArray === 'chosenCustomers' && selectedCheckboxes[0].from_sheet){
          this.cleanSelected(selectedCheckboxes, targetArray)
        }

        this.changeCustomers = true;
        this.fetchPaginatedCustomersToSelect()
        this[`${originArray}Checkbox`] = []
        this.$vs.loading.close('#div-loading-selected > .con-vs-loading')
      },
      cleanSelected(selectedCheckboxes, originArray) {
        // Removes moved customer from array
        if (
          this.selectAll || (
            !selectedCheckboxes[0].from_sheet
            && this[originArray].length === selectedCheckboxes.length
        )) {
          this[originArray] = []
        } else {
          selectedCheckboxes.map(customer => {
            const index = this[originArray].findIndex(c => {
              let tgt;
              let isIndex;

              if (customer.from_sheet) {
                tgt = 'uploadedCustomers'
                isIndex = c.row_number === customer.row_number
              } else {
                tgt = 'customersToSelect'
                isIndex = c.id === customer.id
              }

              if (originArray === 'chosenCustomers' && isIndex) {
                // Merging into customers to select array
                this[tgt] = [
                  ...this[tgt],
                  ...[c]
                ]
              }
              return isIndex
            })

            if (index >= 0) {
              this.removeItemFromArray(originArray, index)
            }
          })
        }
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      removeItemFromArray(arrayName, index) {
        const array = this.$_.cloneDeep(this[arrayName])
        array.splice(index, 1)
        this[arrayName] = array
      },
      setGroupOfCustomerData(data) {
        if (typeof data.customers !== 'undefined' && data.customers.length) {
          const customers = data.customers
          this.setChosenCustomers(customers)
          delete data.customers
        } 

        else if ( data.customers && data.customers.length === 0 ) {
          this.setChosenCustomers([]);
        }

        this.groupOfCustomer = this.$_.cloneDeep(data)
        this.groupOfCustomer.color_tag = this.groupOfCustomer.color_tag ? this.groupOfCustomer.color_tag : '#0491FF'
      },
      setChosenCustomers(customers) {
        const chosenCustomersIds = []

        this.chosenCustomers = customers.map(customerObj => {
          chosenCustomersIds.push(customerObj.id)
          return customerObj
        })
        
        let paginationParams = {
          pagination_page: this.ctsCurrentPage,
          pagination_limit: this.ctsItemsPerPage
        }
      
        this.$store.dispatch("customer/fetchUnchosen", {
          searchParams: paginationParams,
          chosenCustomersIds: chosenCustomersIds
        }).then(res => {
          this.ctsTotalPages = res.data.data.customers.total_pages
          this.parsePaginationResponse(res.data.data.customers)
        })
      },
      errorUploadSheet(response) {
        this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um erro ao subir a planilha!',
          text: response.data.message
        })
      },
      successUploadSheet(response) {
        this.$vs.notify({
          color: 'success',
          title: 'Planilha carregada com sucesso!',
          text: response.data.message
        })

        this.sheet_url = response.data.fileUrl
        this.changeCurrentTab('uploadedCustomers')
        this.$refs.availableTabs.$data.children[0].attrs.disabled = true
      },
      loadDataInTable: function ({results, header, meta}) {
        this.tableData = [];
        this.headerTags = [];
        this.chosenCustomers = [];
        this.columnDefs = this.getColumnDefs();

        this.tableData = results
        this.header = header
        this.sheetName = meta.sheetName
        this.headerTags = header.filter(tag => tag !== 'Nome' && tag !== 'Telefone')
        for (let i in this.headerTags) {
          this.columnDefs.push({field: this.headerTags[i].replace(/\s/g, ''), headerName: this.headerTags[i].replace(/\s/g, '')})
        }
        this.uploadedCustomers = results.map(result => {
          const {Nome, Telefone, __rowNum__} = result
          let mapResult = {
            "id": null,
            "name": Nome,
            "phone_number": Telefone,
            "row_number": __rowNum__,
            "from_sheet": true,
          }

          if (this.headerTags !== null) {
            for (let i in this.headerTags) {
              mapResult[this.headerTags[i].replace(/\s/g, '')] = result[this.headerTags[i]];
            }
          }
          return mapResult;
        })
      },
      submitData() {
        let chosenCustomers = this.chosenCustomers
        const groupOfCustomer = this.$_.cloneDeep(this.groupOfCustomer);
        if (this.updateBySpreadSheet) {
          chosenCustomers = this.uploadedCustomers
          groupOfCustomer.removeRows = []
        } else {
          groupOfCustomer.removeRows = this.uploadedCustomers.map(customer => customer.row_number)
        }

        groupOfCustomer.chosenCustomers = chosenCustomers
            .filter(customer => customer.id)
            .map(customer => customer.id)
        groupOfCustomer.changeCustomers = this.changeCustomers

        this.$validator.validateAll().then(result => {
          if (result) {
            if (groupOfCustomer.id !== null && groupOfCustomer.id >= 0) {
              // Edit
              this.$store.dispatch("customerGroup/updateGroupOfCustomer", groupOfCustomer).then(() => {
                // Redirect to list page
                this.$router.push(formatRouteTenantPath("/crm/category"))
                this.$vs.notify({
                    title: "Sucesso",
                    text: "Categoria atualizada com sucesso",
                    color: "success",
                });
              }).catch(err => {
                console.error(err)
              })
            } else {
              // New
              delete groupOfCustomer.id
              
              groupOfCustomer.sheetUrl = this.sheet_url
              groupOfCustomer.updateAllInSheet = this.update_all_in_sheet
              this.$store.dispatch("customerGroup/addGroupOfCustomer", groupOfCustomer).then(() => {
                // Redirect to list page
                this.$router.push(formatRouteTenantPath("/crm/category"))
                this.$vs.notify({
                    title: "Sucesso",
                    text: "Categoria adicionada com sucesso",
                    color: "success",
                });
              }).catch(err => {
                console.error(err)
              })
            }
          }
        })
      },
      fetchPaginatedCustomersToSelect() {
        let excludeIds = this.excludeIdsInChosen();

        this.$store.dispatch("customer/fetchByCustomerGroup", {
          deleted_at: null,
          pagination_page: this.ctsCurrentPage,
          pagination_limit: this.ctsItemsPerPage,
          name: this.searchTerm,
          exclude: excludeIds
        }).then(res => {
          this.ctsTotalPages = res.data.data.customers.total_pages
          this.parsePaginationResponse(res.data.data.customers)
        })
      },
      parsePaginationResponse(customers) {
        const selectedCustomers = customers.items.map(customer => ({
            "id": customer.id,
            "name": customer.name,
            "phone_number": maskPhoneNumber(customer.phone_number),
            "from_sheet": false
          }))

          let chosenCustomersIds = this.chosenCustomers.map(s => s.id)
          this.customersToSelect = selectedCustomers.filter(c => !chosenCustomersIds.includes(c.id));
      }
    },
    created() {
      this.setGroupOfCustomerData(this.groupOfCustomer);
      this.overlayLoadingTemplate =
          '<span class="ag-overlay-loading-center">Todos os registros selecionados</span>';
      if (!moduleCustomerGroup.isRegistered) {
        this.$store.registerModule('customerGroup', moduleCustomerGroup)
        moduleCustomerGroup.isRegistered = true
      }

      if (!moduleCustomer.isRegistered) {
        this.$store.registerModule('customer', moduleCustomer)
        moduleCustomer.isRegistered = true
      }

      const groupOfCustomerId = this.$route.params.id;

      // The following logic will only work on "update" page
      if (groupOfCustomerId) {
        this.$store
          .dispatch("customerGroup/infosGroupOfCustomer", groupOfCustomerId)
          .then(() =>{ 
            this.setGroupOfCustomerData(this.$store.state.customerGroup.groupOfCustomerInfos)
          })
      } else {
        this.fetchPaginatedCustomersToSelect()
      }
    },
    components: {
      Pagination,
      ImportExcel,
      AgGridVue
    }
  }
</script>

<style scoped>
button.button-remove-bg {
  color: #0B8FFA !important;
}

#button-update {
  width: 1em;
  transform: translateY(-0.3em);
}
</style>
